import { FC, useMemo } from 'react';
import Conditional from '@next-app/components/Conditional';
import { checkoutPageConstant } from '@next-app/constants/CheckoutConstants';
import { AddressInfo } from '@next-app/lib/features/checkout/Checkout.interface';
import {
  selectHasItemFromRegistry,
  selectHasItemFromShippingList,
} from '@next-app/lib/features/checkout/CheckoutSelector';
import { isNotNullOrUndefined } from '@next-app/utils/common-utils';
import { useSelector } from 'react-redux';
import deviceType from '@next-app/utils/get-device-type';
import { extractAddress } from '@next-app/utils/CheckoutHelper';

interface DeliveryAddressForShipUserProps {
  address: AddressInfo;
  checked?: boolean;
  truncateMobile?: boolean;
}

const DeliveryAddressForShipUser: FC<DeliveryAddressForShipUserProps> = ({
  address,
  checked = false,
  truncateMobile = true,
}) => {
  // selectors
  const isRegistryOrder = useSelector(selectHasItemFromRegistry);
  const isClearTheListOrder = useSelector(selectHasItemFromShippingList);
  const hasRegistryOrClearList = isRegistryOrder || isClearTheListOrder;
  const { registryAddressMessage, clearTheListAddressMessage } =
    checkoutPageConstant;

  const {
    firstName,
    lastName,
    companyName,
    address1,
    address2,
    city,
    state,
    postalCode,
    displayName,
  } = address;

  const notMobileView = useMemo(() => deviceType() !== 'mobile', []);

  const isChecked = () => (checked ? 'text-truncate-md' : 'text-truncate');

  return (
    <>
      <Conditional
        if={hasRegistryOrClearList && isNotNullOrUndefined(displayName)}
      >
        <>
          <span>
            <span
              className={`${notMobileView ? 'text-truncate' : ''} d-inline d-md-inline-block align-bottom`}
              style={{ maxWidth: `${notMobileView ? '100px' : ''}` }}
            >
              {firstName} {lastName}
            </span>
            &apos;s {extractAddress(displayName)}
          </span>
        </>
      </Conditional>

      <Conditional if={!hasRegistryOrClearList || displayName === null}>
        <span
          className={` ${truncateMobile ? isChecked() : notMobileView ? isChecked() : ''}`}
        >
          {firstName} {lastName} -{companyName ? ` ${companyName} - ` : ' '}
          {address1}
          {address2 && ` ${address2}`}, {city}, {state} {postalCode}
        </span>
      </Conditional>
    </>
  );
};

export default DeliveryAddressForShipUser;
